import { session } from "../state/session";

export function getActiveClubId(): string {
  const id = session.getActiveClubId();
  if (!id) throw new Error("No active club selected.");
  return id;
}

export function getActiveSeasonId(): string {
  return session.getActiveSeasonId() ?? "2025";
}

export function getActiveTeamId(): string {
  return session.getActiveTeamId() ?? "sunday";
}
